import colors from "colors";
import { IconProps } from "./types";

export default function IcoFile({ color = colors.neutral["low-pure-500"], size = "24" }: IconProps) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.7143 4V9H19M14.7143 4H5V20H19V9M14.7143 4L19 9M16 14H8M12.5 11H8M16 17H8"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
